import { Children, ReactNode, isValidElement, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { matchesMenuRoute } from '../menuRoutes';

interface RouteProps {
    to?: string | { pathname?: string };
    children?: ReactNode;
}

/**
 * Todo `to` que aparece na árvore, em qualquer profundidade — atravessa
 * `<Permission>`, `<CheckChainUsesModule>`, `<FeatureIntro>` e submenu
 * aninhado, porque todos guardam os filhos em `props.children`.
 */
const collectRoutes = (node: ReactNode, found: string[] = []): string[] => {
    Children.forEach(node, child => {
        if (!isValidElement(child)) return;
        const { to, children } = child.props as RouteProps;

        if (typeof to === 'string') {
            found.push(to);
        } else if (to?.pathname) {
            found.push(to.pathname);
        }

        collectRoutes(children, found);
    });

    return found;
};

/**
 * A rota atual está DENTRO deste grupo?
 *
 * É o que acende o ícone do grupo na coluna recolhida: sem isso, estando em
 * "Relatórios › Divergência de Preço" nada no menu dizia por onde a navegação
 * entrou.
 *
 * A varredura é na árvore de ELEMENTOS, não na renderizada: com a barra
 * recolhida o painel só monta no hover, então perguntar aos filhos
 * renderizados não serviria — eles não existem enquanto o painel está fechado.
 */
export const useContainsActiveRoute = (children: ReactNode) => {
    const { pathname } = useLocation();

    return useMemo(
        () => collectRoutes(children).some(to => matchesMenuRoute(pathname, to)),
        [children, pathname]
    );
};
